import React from 'react';
import { AlertModalManagerProps } from '../types';
import SharedDialog from '../../../global/Modal/Modal';

export const AlertModalManager: React.FC<AlertModalManagerProps> = ({ modalContent, isOpen, onClose }) => {
  if (!modalContent) return null;

  const handleConfirm = () => {
    if (modalContent.onConfirm) {
      modalContent.onConfirm();
    }
    onClose();
  };

  const renderBody = () => {
    if (typeof modalContent.body === 'string') {
      return <div dangerouslySetInnerHTML={{ __html: modalContent.body }} />;
    } else if (typeof modalContent.body === 'function') {
      return modalContent.body();
    }
    return null;
  };

  return (
    <SharedDialog
      isOpen={isOpen}
      onClose={onClose}
      title={modalContent.title}
      description={modalContent.description}
      size={modalContent.size || 'md'}
      confirmText={modalContent.confirmText}
      cancelText={modalContent.cancelText || 'Cerrar'}
      hasConfirmBtn={modalContent.hasConfirmBtn}
      onConfirm={handleConfirm}
    >
      {renderBody()}
    </SharedDialog>
  );
};
